export default (error) => ({
	event: 'errorPageStatus',
	errorPageStatusInfo: {
		code: error.app && error.app.status || 500,
		message: `${error.app && error.app.code || 'APP'} | ${error.app && error.app.origin || 'Undefined'} | ${error.name || 'Error'}: ${error.message || 'Undefined'}`
	}
});
